import React, { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
const ErrorContext = createContext({});
const ErrorProvider = (props) => {
    const navigate = useNavigate();
    const routeToErrorPage = (error, info) => {
        const isOnErrorPage = window.location.pathname === '/error';
        if (error && !isOnErrorPage) {
            const lastHref = window.location.pathname + window.location.search;
            navigate('/error', { state: { error, info, lastHref } });
        }
    };
    window.routeToErrorPage = routeToErrorPage;
    const ws = {
        routeToErrorPage,
    };
    return React.createElement(ErrorContext.Provider, Object.assign({ value: ws }, props));
};
const useError = () => {
    const ctx = useContext(ErrorContext);
    if (!ctx) {
        throw new Error('Error Context is only usable under the ErrorProvider in the tree.');
    }
    return ctx;
};
export { ErrorProvider, useError };
